var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhoPageExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.9999C1 11.9999 1.1694 14.8395 1.20877 15.7349C1.26127 16.9357 1.60008 18.2771 2.16555 19.2084C2.96367 20.5285 3.90374 20.9942 5.15877 20.9975C6.6345 21.0007 17.3655 21.0007 18.8412 20.9975C20.0963 20.9942 21.0363 20.5285 21.8344 19.2084C22.3999 18.2771 22.7387 16.9357 22.7924 15.7349C22.8306 14.8395 23 11.9999 23 11.9999",
    fill: "#172741"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.9999C1 11.9999 1.1694 14.8395 1.20877 15.7349C1.26127 16.9357 1.60008 18.2771 2.16555 19.2084C2.96367 20.5285 3.90374 20.9942 5.15877 20.9975C6.6345 21.0007 17.3655 21.0007 18.8412 20.9975C20.0963 20.9942 21.0363 20.5285 21.8344 19.2084C22.3999 18.2771 22.7387 16.9357 22.7924 15.7349C22.8306 14.8395 23 11.9999 23 11.9999",
    stroke: "#4067B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91196 3.21773V2.78489C7.91196 1.36156 9.06462 0.208893 10.488 0.208893H13.5003C14.9225 0.208893 16.0763 1.36156 16.0763 2.78489L16.0775 3.21773",
    fill: "#172741"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9942 16.458V14.9483",
    stroke: "#4067B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20819 6.78721V10.8321C3.44586 12.3079 6.12686 13.3416 9.06919 13.7511C9.42153 12.4666 10.58 11.5251 11.9882 11.5251C13.3742 11.5251 14.556 12.4666 14.885 13.7628C17.8391 13.3533 20.5306 12.3196 22.7799 10.8321V6.78721C22.7799 4.81088 21.1897 3.21954 19.2134 3.21954H4.78636C2.81002 3.21954 1.20819 4.81088 1.20819 6.78721Z",
    fill: "#172741",
    stroke: "#4067B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoPageExperience);
export default __webpack_public_path__ + "static/media/WhoPage-experience.3996eb5ef764e6601f918ef4b2fc9a7d.svg";
export { ForwardRef as ReactComponent };